import React from "react";
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import KCard from "../kCard";
import misc from "../../utils/misc";

const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,               
      },
      '&:last-child td': {        
        fontWeight: 'bold'
      }, 
    },
  }))(TableRow);

const useStyles = theme => ({
    table: {            
    },
    root: {
        flexGrow: 1,        
    },
    bold: {
        fontWeight: 'bold',
    }  
});
/*
class ReviewSection_OLD extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            item: props.item //getStore().terms
        };
        this.classes = useStyles();
    }

    render() {
        const { classes } = this.props;
        return (
            <Box>
                <Grid item xs={12}>
                    <Typography                
                        variant='subtitle1'>{this.state.item.text} HELLO
                    </Typography>
                    
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Description</TableCell>
                                    <TableCell align="right">Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.item.lineItems.map((row, index) => (
                                    <StyledTableRow key={index}>
                                        <TableCell scope="row" >
                                            {row.text}
                                        </TableCell>
                                        <TableCell align="right">{row.formattedAmount}</TableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <br />
                </Grid>
            </Box>
        );
    }
}
*/

/*

function ReviewSection(props) {
    const { item : section, classes } = props;
    const { lineItems } = section;
    
  
    let extraLineItems = section.extraLineItems ? section.extraLineItems : [];
  
    
  
    let students = [];
    if(lineItems.length > 0 && lineItems[0].columns) {
      students = lineItems[0].columns.map( (c) => c.id);
      // console.log('students', students);
    }
  
    const getStudentAmount = (lineItem, student ) => {
      const item = lineItem.columns.find( (c) => c.id === student);
  
      let ret = '';
      
      if(item) {
        if(item.amount === item.fullAmount) ret = `${misc.miscHelper.getWholeDollarAmount(item.amount)}`;
        else {
          ret =  `<del>${misc.miscHelper.getWholeDollarAmount(item.fullAmount)}</del> ${misc.miscHelper.getWholeDollarAmount(item.amount)}`;
        }
      }
      return {__html: ret};
    }
  
    
  
    return (
      <div>
        <KCard title={section.text}>
         
          <Table size="small" className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.bold}>Description</TableCell>
               
                {students.map((student, index) => (              
                  <TableCell className={classes.bold} align="right" key={index}>{student}</TableCell>              
                ))}
                 <TableCell className={classes.bold} align="right" >Total</TableCell>
              </TableRow>
  
            </TableHead>
            <TableBody>
              {lineItems.map((item, index) => (
                <StyledTableRow key={index}>
                  <TableCell>{item.text}</TableCell>
                  {students.map((student, index) => (   
                    
                    <TableCell align="right" key={index}>                       
                    <div dangerouslySetInnerHTML= { getStudentAmount(item, student)} />                       
                    </TableCell> 
                
                  ))}
                  <TableCell align="right">{misc.miscHelper.getWholeDollarAmount(item.amount)}</TableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
  
          <Table size="small">
            <TableBody>  
              {extraLineItems.map((eli, index) => (
                <TableRow key={index}>
                  <TableCell>{eli.text}</TableCell>                
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <div className="your-class mt-3"></div>

        </KCard>
      </div>
    );
  }
*/

  function ReviewSection(props) {
    const { item, splitPayment } = props;  
    const { data } = item;  
    if (!data) return null; // temp code...  
    const { columns } = data;
    let extraLineItems = item.extraLineItems ? item.extraLineItems : [];

    const includeCents = splitPayment;
  
    const getColumnAlignment = (index) => {
      if (index > 0) return "right";
      return "inherit";
    };
  
    return (
      <div>
        <KCard title={item.text}>
          <Table size="small">
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell align={getColumnAlignment(index)} key={index}>
                    {column}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.rows.map((row, index) => (
                <StyledTableRow key={index}>
                  {columns.map((col, index) => (
                    <TableCell align={getColumnAlignment(index)} key={index}>
                      <div dangerouslySetInnerHTML={misc.miscHelper.getReviewColumnText(row, col, includeCents)} />
                    </TableCell>
                  ))}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
          
          <Table size="small">
            <TableBody>
              {extraLineItems.map((eli, index) => (
                <StyledTableRow key={index}>
                  <TableCell>{eli.text}</TableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </KCard>
      </div>
    );
  }
  



export default withStyles(useStyles)(ReviewSection);